export default __webpack_public_path__ + "static/media/backLink.ca844a43.png";